import { isDesktop, isAndroid, isSafari, isIOS } from "react-device-detect";
import moment from "moment";
import { APP_NAMES, USER_TYPES } from "@/config/constants";
import { showSuccessToast } from "./toastr";
const crypto = require("crypto");

const isMobile = (size) => {
  try {
    if (size) {
      if (size < 768) return true;
    }
    if (!size && window) {
      const mob = window.innerWidth < 768;
      return mob;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export { isMobile, isDesktop, isAndroid, isSafari, isIOS };

export const compareTwoStr = (str1, str2) => {
  return str1 && str2 ? str1.toLowerCase() === str2.toLowerCase() : false;
};

export function toAmount(val) {
  if (!val) return null;
  const value =
    +val > 100000
      ? `${val.toString().slice(0, -5)},${val.toString().slice(-5, -3)},${val
          .toString()
          .slice(-3)}`
      : +val > 1000
      ? `${val.toString().slice(0, -3)},${val.toString().slice(-3)}`
      : val;
  return value;
}

export function toAmountFloat(val) {
  if (!val) return null;
  if (val.indexOf(".") !== -1) {
    const valueWithTwoDecimalPlaces = parseFloat(val).toFixed(2);
    const whole = valueWithTwoDecimalPlaces.split(".")[0];
    const decimal = valueWithTwoDecimalPlaces.split(".")[1] || "00";
    const formattedValue = toAmount(whole);
    const finalValue = formattedValue + "." + decimal;
    return finalValue;
  } else {
    return toAmount(val);
  }
}

export const formatDate = (date, format = "YYYY-MM-DD") => {
  let formattedDate = "";
  try {
    formattedDate = moment(date).format(format);
  } catch (err) {
    console.error("Not a date error occured: ", err);
  }
  return formattedDate;
};

export function convertToDecimal(value, translate = false) {
  let unitLacs = " Lakh";
  let unitThousands = "K";

  return value
    ? +value > 100000
      ? `${Math.floor(+value / 1000) / 100}${unitLacs}`
      : `${Math.floor(+value / 100) / 10}${unitThousands}`
    : value;
}

export function titleCaseFormat(name) {
  if (!name) return null;
  return name
    .trim()
    .replace(/\s{2,}/g, " ")
    .split(" ")
    .map((word) => word?.[0]?.toUpperCase() + word?.slice(1)?.toLowerCase())
    .join(" ");
}

export const getAddressJsx = (
  addressLine1,
  addressLine2,
  addressLine3,
  state,
  pinCode
) => {
  const line1 = [addressLine1, addressLine2]
    .filter((s) => s && s.trim().length > 0)
    .join(", ");

  const line2 = [addressLine3, state, pinCode]
    .filter((s) => s && s.trim().length > 0)
    .join(", ");
  return (
    <>
      {line1}
      <br />
      {line2}
    </>
  );
};

export function spaceSeparatedFormat(productName) {
  if (!productName) return null;
  const displayName = productName.replace(/([A-Z])/g, " $1").trim();
  return displayName;
}

export const getCustomerType = (metaData) => {
  if (
    metaData.appName === APP_NAMES.PACE ||
    metaData.appName === APP_NAMES.CRM
  ) {
    return USER_TYPES.EMPLOYEE;
  }
  if (
    metaData.appName === APP_NAMES.IPDS ||
    (metaData.appName === APP_NAMES.EMARINE && metaData.producerCode) ||
    metaData.appName === APP_NAMES.SUPERAPP
  ) {
    return USER_TYPES.AGENT;
  }
  if (
    metaData.appName === APP_NAMES.SUPERAPP ||
    (metaData.appName === APP_NAMES.SUPERAPP && metaData.producerCode)
  ) {
    return USER_TYPES.AGENT;
  }
  return USER_TYPES.CUSTOMER;
};

export const getCustomerTypeBolt = (metaData) => {
  if (
    metaData.appName === APP_NAMES.PACE ||
    metaData.appName === APP_NAMES.CRM
  ) {
    return USER_TYPES.EMPLOYEE;
  }
  if (
    metaData.appName === APP_NAMES.IPDS ||
    (metaData.appName === APP_NAMES.EMARINE && metaData.producerCode) ||
    metaData.appName === APP_NAMES.SUPERAPP
  ) {
    if (metaData?.producerRole === "customersupportretention")
      return USER_TYPES.RETENTION;
    return USER_TYPES.AGENT;
  }
  return USER_TYPES.CUSTOMER;
};

export const calculateAge = (dob, policyExpiryDate) => {
  const today = moment();
  const allowedDateFormats = ["DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss.S"];
  const expiryDate = moment(policyExpiryDate, allowedDateFormats);
  expiryDate.add(1, "day");

  if (today.isAfter(expiryDate)) {
    const age = today.diff(moment(dob, "DD/MM/YYYY"), "years");
    return age;
  } else {
    const age = expiryDate.diff(moment(dob, "DD/MM/YYYY"), "years");
    return age;
  }
};

export const calculateAgeForDOB = (dob) => {
  const today = new Date();
  const birthDate = new Date(dob);
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }
  return age;
};

export function stringFormatting(value) {
  if (!value) return null;
  const a = value.split(/(?=[A-Z])/);
  console.log(a);
  const b = a.join(" ");
  console.log(b);
  return b;
}

export function convertToLac(value) {
  if (typeof value !== "number") {
    throw new Error("Input must be a number");
  }

  const result = value / 100000;
  return result % 1 === 0 ? result.toFixed(0) : result.toFixed(1);
}

export const getFullName = (firstName, middleName, lastName) => {
  const fullName = `${firstName} ${
    middleName ? middleName + " " : ""
  }${lastName}`;

  return fullName;
};

export const encrypt_AES_128_CBC = (SALT, text) => {
  const key = Buffer.from(SALT, "utf-8");
  const cipher = crypto.createCipheriv("aes-128-cbc", key, Buffer.alloc(16));
  let cipherText = cipher.update(text, "utf8", "base64");
  cipherText += cipher.final("base64");

  const encryptedText = Buffer.concat([
    Buffer.alloc(16),
    Buffer.from(cipherText, "base64"),
  ]);
  const base64EncodedEncryptedText = encryptedText.toString("base64");

  return base64EncodedEncryptedText;
};

export const getFullNameWithSalutation = (
  firstName,
  middleName,
  lastName,
  salutation
) => {
  const fullName = `${salutation ? salutation + " " : ""}${firstName} ${
    middleName ? middleName + " " : ""
  }${lastName}`;

  return fullName.toUpperCase();
};

export const onlyAlphabets = (e) => {
  const charCode = e.which ? e.which : e.keyCode;
  if (
    !(charCode >= 65 && charCode <= 90) && // A-Z
    !(charCode >= 97 && charCode <= 122) && // a-z
    charCode !== 32 && // space
    charCode !== 45 && // hyphen
    charCode !== 39 && // apostrophe
    charCode !== 8 && // backspace
    charCode !== 45 && // minus
    charCode !== 189 && // minus
    charCode !== 9
  ) {
    // tab
    e.preventDefault();
  }
};

export const onlyNumbers = (e) => {
  // Allow backspace, left and right arrow keys, and numbers (0-9)
  if (
    !(
      (
        (e.keyCode > 47 && e.keyCode < 58) || // Numbers from keyboard
        (e.keyCode > 95 && e.keyCode < 106) || // Numbers from numpad
        e.keyCode === 8 || // Backspace
        e.keyCode === 37 || // Left arrow
        e.keyCode === 39
      ) // Right arrow
    ) ||
    (e.shiftKey && e.keyCode !== 8) // Disallow special characters
  ) {
    // Control keys
    e.preventDefault();
  }
};

export const alphaNamePaste = (e) => {
  var regex = new RegExp(/^[ A-Za-z]*$/);
  var str = e.clipboardData.getData("Text");
  if (regex.test(str)) {
    return true;
  } else {
    e.preventDefault();
    return false;
  }
};
// export const onlyDate = (e) => {
//   // Allowed characters in a date (digits, hyphen, slash)
//   const allowedCharacters = /^[0-9/-]+$/;

//   // Check if the input character matches the allowed characters
//   return allowedCharacters.test(e.key);
// }

export const onlyDate = (evt) => {
  let temp = evt?.target?.value;
  if (!(temp.length > 9)) {
    if (
      (evt.key >= "0" && evt.key <= "9") ||
      evt.key == "Backspace" ||
      evt.key == "Delete" ||
      evt.key == "ArrowLeft" ||
      evt.key == "ArrowRight"
    ) {
      return true;
    }
  }
  return false;
};

export function convertHeightAndCalculateBMI(heightCm, weightKg) {
  const inchesPerCm = 0.3937008;
  const cmPerMeter = 100;

  const heightInInches = heightCm * inchesPerCm;
  const feet = Math.floor(heightInInches / 12);
  const inches = Math.round(heightInInches % 12);

  const heightInMeters = heightCm / cmPerMeter;
  const bmi = weightKg / (heightInMeters * heightInMeters);

  return {
    heightFeet: feet,
    heightInches: inches,
    bmi: bmi.toFixed(2),
  };
}

export const copyToClipboard = (text, message) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      showSuccessToast(message);
    })
    .catch((err) => {
      console.error("Failed to copy: ", err);
    });
};
